import actions from './actions'
import { initialDataState, reduceDataError, reduceDataRequest, reduceDataSuccess } from '../../../reducersHelper'

const initState = {
  unifiedEmar: initialDataState
}

const reducers = (state = initState, action) => {
  switch (action.type) {
    case actions.CLEAR_SERVICEUSER_EMAR:
      return initState

    case actions.GET_SERVICEUSER_UNIFIED_EMAR_REQUEST:
      return reduceDataRequest(state, 'unifiedEmar')
    case actions.GET_SERVICEUSER_UNIFIED_EMAR_SUCCESS:
      return reduceDataSuccess(state, 'unifiedEmar', action.payload)
    case actions.GET_SERVICEUSER_UNIFIED_EMAR_ERROR:
      return reduceDataError(state, 'unifiedEmar', action.error)

    default:
      return state
  }
}

export default reducers
